module.exports = __webpack_public_path__ + "static/media/eyestalk.d2c2b188.svg";